import { render, staticRenderFns } from "./Cupoms.vue?vue&type=template&id=b31b730e"
import script from "./Cupoms.vue?vue&type=script&lang=js"
export * from "./Cupoms.vue?vue&type=script&lang=js"
import style0 from "./Cupoms.vue?vue&type=style&index=0&id=b31b730e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports